
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Sample } from '../../components';

@Component({
    selector: 'app-layout',
    imports: [Sample],
    templateUrl: './layout.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout.scss'
})
export class Layout {}
